var map = {
	"./alcohol-in-gel.png": 370,
	"./analgesic.png": 371,
	"./apple.png": 372,
	"./bandages.png": 373,
	"./mask.png": 374,
	"./repellent.png": 375,
	"./sandwich.png": 376,
	"./sedative.png": 377,
	"./sunscreen.png": 378,
	"./water.png": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 258;